/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=35b14742"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35b14742&lang=css"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__